
import React, { Component } from 'react'
import './App.css';

import '@js-temporal/polyfill';
import Home from './pages/Home.js'
import Jobs from './pages/Jobs.js'
import About from './pages/About.js'
import Contact from './pages/Contact.js'
import Service from './pages/Service.js'
import LocationFetcher from './pages/LocationFetcher.js'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import Lenis from 'lenis';
import Login from './pages/Login.js';
import Cart from './pages/Cart.js';
import Package from './pages/Package.js';
import { CartProvider } from "./context/CartContext";
import Profile from './pages/Profile.js';
import PaymentSuccess from './pages/PaymentSuccess.js';
import Conditions from './pages/Conditions.js';
import Dashboard from './pages/Dashboard.js';
import AddCustomer from './pages/AddCustomer.js';
import AddAppointment from './pages/AddAppointment.js';
import Appointment from './pages/Appointment.js';
import AppointmentTimeline from './pages/AppointmentTimeline.js';
import WhatsappChat from './pages/WhatsappChat.js';
import Broadcast from './pages/Broadcast.js';
import WhatsappAppointments from './pages/WhatsappAppointments.js';
import PrivacyPolicy from './pages/PrivactPolicy.js';
import Transactions from './pages/Transactions.js';
import DashboardReports from './pages/DashboardReports.js';
import ManualPayments from './pages/ManualPayments.js';
import Payment from './pages/Payment.js';
import PaymentLink from './pages/PaymentLink.js';
import AuthBlog from './pages/AuthBlog.js';
import UrlPermission from './pages/UrlPermission.js';
import Blog from './pages/Blog.js';
import BlogDetail from './pages/BlogDetail.js';
import ProtectedRoute from './utils/ProtectedRoute.jsx';
import AddEmployee from './pages/AddEmployee.js';
import Managepartner from './pages/Managepartner.js';
import ManageSalary from './pages/ManageSalary.js';
import ManagePackages from './pages/ManagePackages.js';
import ManagePromotions from './pages/ManagePromotions.js';
import EmployeeFeedback from './pages/EmployeeFeedback.js';
import EmployeeDayOff from './pages/EmployeeDayOff.js';



export default class App extends Component {
  componentDidMount() {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
      direction: 'vertical', // vertical, horizontal
      gestureDirection: 'vertical', // vertical, horizontal, both
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  render() {
    return (
      <Router>
        <CartProvider>
          <NotificationContainer />
          <Routes>
            <Route key='home' path='/' element={<Home />} />
            <Route exact path='/about' element={<About />} key='about' />
            <Route exact path='/contact' element={<Contact />} key='contact' />
            <Route exact path='/jobs' element={<Jobs />} key='jobs' />
            <Route exact path='/service' element={<Service />} key='service' />
            <Route exact path='/location-fetcher' element={<LocationFetcher />} key='locationFetcher' />

            <Route exact path='/login' element={<Login />} key='login' />
            <Route exact path='/cart' element={<Cart />} key='cart' />
            <Route exact path='/package' element={<Package />} key='package' />
            <Route exact path='/profile' element={<Profile />} key='profile' />
            <Route exact path='/paymentstatus' element={<PaymentSuccess />} key='paymentstatus' />
            <Route exact path='/conditions' element={<Conditions />} key='conditions' />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/payment-link/:key' element={<PaymentLink />} />
            <Route path='/blog' element={<Blog />} />
            <Route path='/blog/:slug' element={<BlogDetail />} />
            <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /></ProtectedRoute>} key="dashboard">
              <Route index element={<ProtectedRoute permission="Dashboard Data Listing - Management">
                <DashboardReports /></ProtectedRoute>} />
              <Route path="add-customer" element={<ProtectedRoute permission="Customer List & Create - Management">
                <AddCustomer /> </ProtectedRoute>} />
              <Route path='add-appointment' element={<ProtectedRoute permission="Create Appointment Range - Management">
                <AddAppointment /> </ProtectedRoute>} />
              <Route path="add-appointment/:id" element={<ProtectedRoute permission="Create Appointment Range - Management">
                <AddAppointment /> </ProtectedRoute>} />
              <Route path='whatsappchat' element={<ProtectedRoute permission="WhatsApp Chat - Management">
                <WhatsappChat /> </ProtectedRoute>} />
              <Route path='appointment' element={<ProtectedRoute permission="All Appointments - Management"><Appointment /> </ProtectedRoute>} />
              <Route path='appointment-timeline' element={<ProtectedRoute permission="Employee Timeline - Management">
                <AppointmentTimeline />  </ProtectedRoute>} />
              <Route path='broadcast-message' element={<ProtectedRoute permission="Send WhatsApp Bulk - Management">
                <Broadcast /> </ProtectedRoute>} />
              <Route path='whatsapp-appointment' element={<ProtectedRoute permission="WhatsApp Appointments - Management">
                <WhatsappAppointments /> </ProtectedRoute>} />
              <Route path='transactions' element={<ProtectedRoute permission="Payment Transactions - Management">
                <Transactions /> </ProtectedRoute>} />
              <Route path='payment-details' element={<ProtectedRoute permission="Payment Transactions - Management">
                <ManualPayments /> </ProtectedRoute>} />
              <Route path='payment' element={<ProtectedRoute permission="Payment Link - Management">
                <Payment />  </ProtectedRoute>} />
              <Route path='auth-blog' element={<ProtectedRoute permission="Blogs List - Management">
                <AuthBlog /> </ProtectedRoute>} />
              <Route path='url_permission' element={<ProtectedRoute permission="URL Permissions Handle - Management">
                <UrlPermission /> </ProtectedRoute>} />
              <Route path='url_permission' element={<ProtectedRoute permission="URL Permissions Handle - Management">
                <UrlPermission /> </ProtectedRoute>} />

              <Route path="add-employee" element={<ProtectedRoute permission="Add Employee AllUser - Management">
                <AddEmployee /> </ProtectedRoute>} />

              <Route path="manage-partner" element={<ProtectedRoute permission="Manage Partner Employee - Management">
                <Managepartner /></ProtectedRoute>} />
              <Route path='manage-salary' element={<ProtectedRoute permission="Manage Salary - Management">
                 <ManageSalary /></ProtectedRoute>}></Route>
              <Route path='manage-packages' element={<ProtectedRoute permission="Manage Packages - Management">
                <ManagePackages /> </ProtectedRoute>}></Route>
                <Route path='manage-promotions' element={<ProtectedRoute permission="Manage Promotions - Management">
                  <ManagePromotions/> </ProtectedRoute>}></Route>
              <Route path='employee-feedback' element={<ProtectedRoute permission="Employee Feedback - Management">
                <EmployeeFeedback/> </ProtectedRoute>}></Route>
                <Route path='employee-dayoff' element={<ProtectedRoute permission="Employee Day Off - Management">
                  <EmployeeDayOff/></ProtectedRoute>}></Route>
                
                 
            </Route>
          </Routes>
        </CartProvider>
      </Router>

    )
  }
}

